import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { QueryKey } from "../../../consts/query-keys";

export const useBiodiversityData = (shouldFetchData: boolean) => {
  const { datasetId, id } = useParams();
  const { data: biodiversityData, isPending } = useQuery({
    queryKey: [QueryKey.Biodiversity, datasetId, id],
    queryFn: () =>
      Plants.getBiodiversity({
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      }),
    throwOnError: true,
    enabled: shouldFetchData,
  });

  return { biodiversityData, isPending };
};
